import { FolderOpen } from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";
import { StatCard, SectionHeader, ChartTooltipContent, PIE_COLORS } from "./ReportsShared";

export const DocumentTrackingSection = ({ document_tracking }) => (
  <section data-testid="section-documents" id="section-documents">
    <SectionHeader icon={FolderOpen} title="Document Tracking" subtitle="Upload activity and coverage gaps" />
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
      <StatCard icon={FolderOpen} label="Total Documents" value={document_tracking.total_documents} color="#2563eb" />
      {document_tracking.by_category.map((c) => (
        <StatCard key={c.category} icon={FolderOpen} label={c.category} value={c.count} color={PIE_COLORS[["Contracts", "Inspections", "Disclosures", "Other"].indexOf(c.category)] || "#64748b"} />
      ))}
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <Card className="card-surface" data-testid="upload-activity-chart">
        <CardHeader className="py-3 px-5">
          <CardTitle className="text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--t-text-muted)" }}>Upload Activity (Monthly)</CardTitle>
        </CardHeader>
        <CardContent className="px-2 pb-4">
          {document_tracking.uploads_by_month.length > 0 ? (
            <ResponsiveContainer width="100%" height={200}>
              <BarChart data={document_tracking.uploads_by_month} barSize={28}>
                <CartesianGrid strokeDasharray="3 3" stroke="var(--t-border)" />
                <XAxis dataKey="month" tick={{ fontSize: 11, fill: "var(--t-text-muted)" }} />
                <YAxis tick={{ fontSize: 11, fill: "var(--t-text-muted)" }} allowDecimals={false} />
                <Tooltip content={<ChartTooltipContent />} />
                <Bar dataKey="count" name="Uploads" fill="#7c3aed" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <p className="text-center py-10 text-sm" style={{ color: "var(--t-text-muted)" }}>No uploads yet</p>
          )}
        </CardContent>
      </Card>
      <Card className="card-surface" data-testid="missing-docs-card">
        <CardHeader className="py-3 px-5">
          <CardTitle className="text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--t-text-muted)" }}>Missing Documents (Active Transactions)</CardTitle>
        </CardHeader>
        <CardContent className="p-0 max-h-[240px] overflow-y-auto">
          {document_tracking.missing_documents.length > 0 ? (
            <div className="divide-y" style={{ borderColor: "var(--t-border-light)" }}>
              {document_tracking.missing_documents.map((t) => (
                <Link to={`/transactions/${t.transaction_id}`} key={t.transaction_id} className="flex items-center justify-between px-5 py-2.5 text-xs hover:bg-[var(--t-row-hover)] transition-colors">
                  <span className="font-medium truncate mr-3" style={{ color: "var(--t-text)" }}>{t.address}</span>
                  <div className="flex gap-1 flex-shrink-0">
                    {t.missing_categories.map((c) => (
                      <span key={c} className="px-1.5 py-0.5 rounded text-[10px] font-medium" style={{ background: "#fef2f2", color: "#dc2626" }}>{c}</span>
                    ))}
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <p className="text-center py-10 text-sm" style={{ color: "#059669" }}>All active transactions have documents in every category!</p>
          )}
        </CardContent>
      </Card>
    </div>
  </section>
);
